<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header bg-accent-grad glow-accent text-center">
                        <h3 class="text-white mb-0">کیف پول من</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">موجودی کیف پول شما :
                                    {{myBalance.toLocaleString()}}
                                </h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-light text-left"
                                            @click="onPrintClicked()"><i class="fa fa-print"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div id="printMe">
                            <div class="row" v-if="isCapital">
                                <div class="card-header admin-header w-100 text-center">

                                    <h5 class="text-accent-light w-100 ">سهم سرمایه من</h5>
                                </div>
                                <div class="row w-100">
                                    <h6 class="col-4">کل سرمایه شرکت :
                                        {{capital.totalCapital.toLocaleString() }}</h6>
                                    <h6 class="col-4">کل سرمایه من :
                                        {{capital.myRecipts.toLocaleString()}}</h6>
                                    <h6 class="col-4">درصد سرمایه من :
                                        {{capital.myPrecent}} %</h6>
                                </div>
                                <div class="card-header admin-header w-100 text-center">

                                    <h5 class="text-accent-light w-100 ">لیست پرداختهای من</h5>
                                </div>
                                <div class="table-responsive">
                                    <div v-if="!isLoading">
                                        <preloader/>
                                    </div>
                                    <div v-else>
                                        <div v-if="myreciptsList.length===0">
                                            <p class="text-center mt-3">هیچ برداشتی ثبت نشده است.</p>

                                        </div>
                                        <div v-else>
                                            <table class="table table-hover table-striped mb-3">
                                                <thead>
                                                <tr>
                                                    <th>تاریخ پرداخت</th>
                                                    <th>مبلغ پرداخت</th>
                                                    <th>محل هزینه</th>
                                                    <th>نوع پرداخت</th>
                                                    <!--<th class="text-nowrap">شرح</th>-->
                                                    <!--<th>نام مهندس</th>-->
                                                    <th>شرح</th>
                                                    <!--<th class="text-center">عملیات</th>-->
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="it in myreciptsList">

                                                    <td class="text-nowrap">{{it.fDate}}</td>
                                                    <td class="text-nowrap">{{it.price.toLocaleString() }}</td>
                                                    <td class="text-nowrap">{{it.payForName }}</td>
                                                    <td class="text-nowrap">{{it.paymentTypeName }}</td>

                                                    <td>{{it.description}}</td>

                                                </tr>
                                                <tr>
                                                    <td rowspan="2">جمع :</td>
                                                    <td rowspan="2">{{myreciptsList.reduce( (acc, item) => { return
                                                        acc
                                                        +=
                                                        item.price; }, 0).toLocaleString()}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="card-header admin-header w-100 text-center">

                                    <h5 class="text-accent-light w-100 ">برداشتها</h5>
                                    <div class="text-left">

                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <div v-if="!isLoading">
                                        <preloader/>
                                    </div>
                                    <div v-else>
                                        <div v-if="mycomapyPayments.length===0">
                                            <p class="text-center mt-3">هیچ برداشتی ثبت نشده است.</p>

                                        </div>
                                        <div v-else>
                                            <table class="table table-hover table-striped mb-3">
                                                <thead>
                                                <tr>
                                                    <th>تاریخ پرداخت</th>
                                                    <th>مبلغ پرداخت</th>
                                                    <th>محل هزینه</th>
                                                    <th>نوع پرداخت</th>
                                                    <!--<th class="text-nowrap">شرح</th>-->
                                                    <!--<th>نام مهندس</th>-->
                                                    <th>شرح</th>
                                                    <!--<th class="text-center">عملیات</th>-->
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="it in mycomapyPayments">

                                                    <td class="text-nowrap">{{it.fDate}}</td>
                                                    <td class="text-nowrap">{{it.price.toLocaleString() }}</td>
                                                    <td class="text-nowrap">{{it.payForName }}</td>
                                                    <td class="text-nowrap">{{it.paymentTypeName }}</td>
                                                    <!--<td class="text-nowrap">{{it.description}}-->
                                                    <!--&lt;!&ndash;{{it.userFullName !== null && it.userFullName&ndash;&gt;-->
                                                    <!--&lt;!&ndash;!== ''&ndash;&gt;-->
                                                    <!--&lt;!&ndash;?it.userFullName :&ndash;&gt;-->
                                                    <!--&lt;!&ndash;it.engineerFullName !== null && it.engineerFullName !== ''&ndash;&gt;-->
                                                    <!--&lt;!&ndash;?it.engineerFullName:&ndash;&gt;-->
                                                    <!--&lt;!&ndash;it.projectName !== null && it.projectName !== ''&ndash;&gt;-->
                                                    <!--&lt;!&ndash;?it.projectName:&ndash;&gt;-->
                                                    <!--&lt;!&ndash;it.contractName !== null && it.contractName !== ''&ndash;&gt;-->
                                                    <!--&lt;!&ndash;?it.contractName:'&#45;&#45;'&ndash;&gt;-->
                                                    <!--&lt;!&ndash;}}&ndash;&gt;-->
                                                    <!--</td>-->
                                                    <!--<td>{{it.engineerFullName == null || it.engineerFullName == '' ?-->
                                                    <!--'&#45;&#45;':it.engineerFullName}}-->
                                                    <!--</td>-->
                                                    <td>{{it.description}}</td>
                                                    <!--<td class="text-center text-nowrap"><i-->
                                                    <!--class="fa fa-pencil-square-o px-3 clickable"-->
                                                    <!--style="font-size: larger"-->
                                                    <!--@click="editItem(it)"-->
                                                    <!--title="ویرایش آیتم"></i>-->
                                                    <!--| <i class="fa fa-trash-o px-3 clickable"-->
                                                    <!--style="font-size: larger"-->
                                                    <!--@click="deleteItem(it)"-->
                                                    <!--title="حذف آیتم"></i>-->
                                                    <!--</td>-->

                                                </tr>
                                                <tr>
                                                    <td rowspan="2">جمع :</td>
                                                    <td rowspan="2">{{mycomapyPayments.reduce( (acc, item) => { return
                                                        acc
                                                        +=
                                                        item.price; }, 0).toLocaleString()}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="card-header admin-header w-100 text-center">

                                    <h5 class="text-accent-light w-100">درآمدها</h5>
                                    <div class="text-left">

                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <div v-if="!isLoading">
                                        <preloader/>
                                    </div>
                                    <div v-else>
                                        <div v-if="myrecipts.length===0">
                                            <p class="text-center mt-3">هیچ درآمدی ثبت نشده است.</p>

                                        </div>
                                        <div v-else>
                                            <table class="table table-hover table-striped mb-3">
                                                <thead>
                                                <tr>
                                                    <th>تاریخ دریافت</th>
                                                    <th>حق السهم</th>
                                                    <th>مبلغ کل فروش</th>
                                                    <th>وصول شده</th>
                                                    <th>حق السهم وصول شده</th>
                                                    <!--<th>نوع دریافت</th>-->
                                                    <th>نام محصول</th>
                                                    <th>نام مشتری</th>
                                                    <!--<th>توضیحات</th>-->
                                                    <!--<th class="text-center">عملیات</th>-->
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="it in myrecipts">

                                                    <td class="text-nowrap">{{it.fDate}}</td>
                                                    <td class="text-nowrap">{{it.price.toLocaleString()}}</td>
                                                    <td class="text-nowrap">{{it.totalPrice.toLocaleString()}}</td>
                                                    <td class="text-nowrap">{{it.recipt.toLocaleString()}}</td>
                                                    <td class="text-nowrap">
                                                        {{(it.recipt*it.price/it.totalPrice).toLocaleString()}}
                                                    </td>
                                                    <!--<td class="text-nowrap">{{it.paymentTypeName }}</td>-->
                                                    <td class="text-nowrap">{{it.name}}
                                                    </td>
                                                    <td class="text-nowrap">{{it.fullName}}
                                                    </td>
                                                    <!--<td class="text-nowrap">{{it.description}}</td>-->
                                                    <!--<td class="text-center text-nowrap"><i-->
                                                    <!--class="fa fa-pencil-square-o px-3 clickable"-->
                                                    <!--style="font-size: larger"-->
                                                    <!--@click="editItem(it)"-->
                                                    <!--title="ویرایش آیتم"></i>-->
                                                    <!--| <i class="fa fa-trash-o px-3 clickable"-->
                                                    <!--style="font-size: larger"-->
                                                    <!--@click="deleteItem(it)"-->
                                                    <!--title="حذف آیتم"></i>-->
                                                    <!--</td>-->

                                                </tr>
                                                <tr>
                                                    <td rowspan="2">جمع :</td>
                                                    <td rowspan="2">{{myrecipts.reduce( (acc, item) => { return acc +=
                                                        item.price; }, 0).toLocaleString()}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="card-header admin-header w-100 text-center">

                                    <h5 class="text-accent-light w-100">درآمدهای زیرمجموعه</h5>
                                    <div class="text-left">

                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <div v-if="!isLoading">
                                        <preloader/>
                                    </div>
                                    <div v-else>
                                        <div v-if="myClonirecipts.length===0">
                                            <p class="text-center mt-3">هیچ درآمدی ثبت نشده است.</p>

                                        </div>
                                        <div v-else>
                                            <table class="table table-hover table-striped mb-3">
                                                <thead>
                                                <tr>
                                                    <th>تاریخ دریافت</th>
                                                    <th>حق السهم</th>
                                                    <th>مبلغ کل فروش</th>
                                                    <th>وصول شده</th>
                                                    <th>حق السهم وصول شده</th>
                                                    <!--<th>نوع دریافت</th>-->
                                                    <th>نام محصول</th>
                                                    <th>نام مشتری</th>
                                                    <!--<th>توضیحات</th>-->
                                                    <!--<th class="text-center">عملیات</th>-->
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="it in myClonirecipts[0]">

                                                    <td class="text-nowrap">{{it.fDate}}</td>
                                                    <td class="text-nowrap">{{it.price.toLocaleString()}}</td>
                                                    <td class="text-nowrap">{{it.totalPrice.toLocaleString()}}</td>
                                                    <td class="text-nowrap">{{it.recipt.toLocaleString()}}</td>
                                                    <td class="text-nowrap">
                                                        {{(it.recipt*it.price/it.totalPrice).toLocaleString()}}
                                                    </td>
                                                    <!--<td class="text-nowrap">{{it.paymentTypeName }}</td>-->
                                                    <td class="text-nowrap">{{it.name}}
                                                    </td>
                                                    <td class="text-nowrap">{{it.fullName}}
                                                    </td>
                                                    <!--<td class="text-nowrap">{{it.description}}</td>-->
                                                    <!--<td class="text-center text-nowrap"><i-->
                                                    <!--class="fa fa-pencil-square-o px-3 clickable"-->
                                                    <!--style="font-size: larger"-->
                                                    <!--@click="editItem(it)"-->
                                                    <!--title="ویرایش آیتم"></i>-->
                                                    <!--| <i class="fa fa-trash-o px-3 clickable"-->
                                                    <!--style="font-size: larger"-->
                                                    <!--@click="deleteItem(it)"-->
                                                    <!--title="حذف آیتم"></i>-->
                                                    <!--</td>-->

                                                </tr>
                                                <tr>
                                                    <td rowspan="2">جمع :</td>
                                                    <td rowspan="2">{{myClonirecipts[0].reduce( (acc, item) => { return
                                                        acc +=
                                                        item.price; }, 0).toLocaleString()}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import DatePicker from '../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../_framework/VsSelect";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import Vue from 'vue';

    export default {
        name: "userWallet",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isLoading: false,
                mycomapyPayments: [],
                payFors: [],
                payTypes: [],
                myrecipts: [],
                myreciptsList: [],
                myClonirecipts: [],
                myBalance: 0,
                isCapital: false,
                capital: {},

            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.getEncomapyPayment();
            this.getEnpaymentType();

            this.getMyWallet();


        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            getMyWallet() {
                new BaseService("UserWallet", "/GetUserWallet").getList().then(response => {
                        if (response.data.enRole === 7) {
                            this.isCapital = true;
                            new BaseService("UserWallet", "/GetCapitall").getList().then(response1 => {
                                this.capital = response1.data;
                                this.myreciptsList = response1.data.myReciptsList;
                            }).catch(error => {
                                console.log(error)
                                Utils.handleErrorWithNotification(error.data, this.$noty);
                            });
                        }
                        this.mycomapyPayments = response.data.myPay;
                        this.myBalance = response.data.walletBalance;
                        if (this.mycomapyPayments.length > 0) {
                            for (let it of this.mycomapyPayments) {
                                it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                                for (let fo of this.payFors) {
                                    if (it.payFor == fo.value) {
                                        it.payForName = fo.title;
                                    }
                                }
                                for (let ty of this.payTypes) {
                                    if (it.paymentType == ty.value) {
                                        it.paymentTypeName = ty.title;
                                    }
                                }

                            }
                        }
                        this.myrecipts = response.data.myRecipts;
                        if (this.myrecipts.length > 0) {
                            for (let it of this.myrecipts) {
                                it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                                // for (let j of this.payTypes) {
                                //     if (it.paymentType === j.value) {
                                //         it.paymentTypeName = j.title;
                                //     }
                                // }
                            }
                        }
                        this.myClonirecipts = response.data.myCloniRecipts;
                        if (this.myClonirecipts.length > 0) {
                            for (let it of this.myClonirecipts[0]) {
                                it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                                // for (let j of this.payTypes) {
                                //     if (it.paymentType === j.value) {
                                //         it.paymentTypeName = j.title;
                                //     }
                                // }
                            }
                        }
                        this.isLoading = true;
                    }
                ).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getEncomapyPayment() {
                new BaseService("Enum", "/GetEnPayment").getList().then(response => {
                    this.payFors = response.data;
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            }
            ,
            getEnpaymentType() {
                new BaseService("Enum", "/GetEnPaymentType").getList().then(response => {
                    this.payTypes = response.data;
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            }
            ,

        }
    }
</script>

<style lang="scss" scoped>
    .userWallet-image {
        margin: 0 auto 1rem auto;
    }

    .userWallet-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>